// Подсчет ингредиентов суммарно в плане
export function Checking (arr, recipes, ingredients) { 
    const plan = arr.map((v)=> {
      let food=[] 
      const dex = {...v}
      Object.values(dex).map((d) => {  
        if(Array.isArray(d) && d.length> 0) {  
          const fin = d.filter(i=>!i.weight)
          fin.map(item => {  
            let showRecipe = recipes.find(r => r._id === item._id)
            if(showRecipe !== undefined) {
            showRecipe.ingredients.map((i, index) =>  {
              const ingBase = ingredients.find(c=> c._id === i._id)  
          //на первой позиции
          if(food.length === 0 ) {
            let weight
            if(i.choisMeasure === ingBase.mainMeasure) {
              weight = Number(i.weight)/showRecipe.servings
            } else if(i.choisMeasure !== ingBase.mainMeasure) {
                const crow = ingBase.measure.find(function (j) { 
                  return j.nameRu.includes(i.choisMeasure);  
                })
                weight = (crow.ratio*Number(i.weight))/showRecipe.servings
              }
              food.push({weight: weight, choisMeasure: ingBase.mainMeasure, id: i._id})   
          } //если в result есть данные 
          else {
            //Проверка наличия этого ингредиента в result
            let check = food.find(с => с.id === i._id)  
            //если есть в массиве то просто прибавляем вес ингредиента
            if(check) {
              food.map((z) => {
                if(z.id === i._id) {
                  if(i.choisMeasure === ingBase.mainMeasure) {
                    z.weight += Number(i.weight)/showRecipe.servings
                  } else if(i.choisMeasure !== ingBase.mainMeasure) {
                    const crow = ingBase.measure.find(function (j) { 
                      return j.nameRu.includes(i.choisMeasure);  
                    })
                    z.weight += crow.ratio*Number(i.weight)/showRecipe.servings
                  }  
                }
              })
            } //если нет ингредиента, то добавляем новый в result
              else if (check === undefined) {
                let weight=0
                if(i.choisMeasure === ingBase.mainMeasure) {
                  weight =  Number(i.weight)/showRecipe.servings
                } else if(i.choisMeasure !== ingBase.mainMeasure) {
                  const crow = ingBase.measure.find(function (j) {  
                    return j.nameRu.includes(i.choisMeasure);  
                  }) 
                  weight = (crow.ratio*Number(i.weight))/showRecipe.servings 
                } 
                food.push({weight: weight, choisMeasure: ingBase.mainMeasure, id: i._id})   
              }
          }
        })
      }
         })
        }
      }) 
      dex.foodList = food 
      return dex
    })
    return plan
  }

// Подсчет ингредиентов на один день

export function CheckingOne (arr, recipes, ingredients) { 
    let food=[]
    const dex = {...arr}
    Object.values(dex).map((d) => { 
      if(Array.isArray(d) && d.length> 0) {  
        const fin = d.filter(i=>!i.weight)
        fin.map(item => {
          let showRecipe = recipes.find(r => r._id === item)
          if(showRecipe !== undefined) {
          showRecipe.ingredients.map((i, index) =>  {
            const ingBase = ingredients.find(c=> c._id === i._id)  
        //на первой позиции
        if(food.length === 0 ) {
          let weight
          if(i.choisMeasure === ingBase.mainMeasure) {
            weight = Number(i.weight)/showRecipe.servings
          } else if(i.choisMeasure !== ingBase.mainMeasure) {
              const crow = ingBase.measure.find(function (j) { 
                return j.nameRu.includes(i.choisMeasure);  
              })
              weight = (crow.ratio*Number(i.weight))/showRecipe.servings
            }
            food.push({weight: weight, choisMeasure: ingBase.mainMeasure, id: i._id})   
        } //если в result есть данные 
        else {
          //Проверка наличия этого ингредиента в result
          let check = food.find(с => с.id === i._id)  
          //если есть в массиве то просто прибавляем вес ингредиента
          if(check) {
            food.map((z) => {
              if(z.id === i._id) {
                if(i.choisMeasure === ingBase.mainMeasure) {
                  z.weight += Number(i.weight)/showRecipe.servings
                } else if(i.choisMeasure !== ingBase.mainMeasure) {
                  const crow = ingBase.measure.find(function (j) { 
                    return j.nameRu.includes(i.choisMeasure);  
                  })
                  z.weight += crow.ratio*Number(i.weight)/showRecipe.servings
                }  
              }
            })
          } //если нет ингредиента, то добавляем новый в result
            else if (check === undefined) {
              let weight=0
              if(i.choisMeasure === ingBase.mainMeasure) {
                weight =  Number(i.weight)/showRecipe.servings
              } else if(i.choisMeasure !== ingBase.mainMeasure) {
                const crow = ingBase.measure.find(function (j) { 
                  return j.nameRu.includes(i.choisMeasure);  
                })
                weight =  (crow.ratio*Number(i.weight))/showRecipe.servings 
              } 
              food.push({weight: weight, choisMeasure: ingBase.mainMeasure, id: i._id})   
            }
        }
      })
    }
       })
      }
    })
    dex.foodList = food
    return dex
}

export function DishChecking (arr, recipes, ingredients) {
  let food=[]
  const plan = arr.map((v)=> {
    const dex = {...v}
    Object.values(dex).map((d) => { 
      if(Array.isArray(d) && d.length> 0) {  
        const fin = d.filter(i=>!i.weight)
        fin.map(item => {
          let showRecipe = recipes.find(r => r._id === item)
          if(showRecipe !== undefined) {
          showRecipe.ingredients.map((i, index) =>  {
            const ingBase = ingredients.find(c=> c._id === i._id)  
        //на первой позиции
        if(food.length === 0 ) {
          let weight
          if(i.choisMeasure === ingBase.mainMeasure) {
            weight = Number(i.weight)/showRecipe.servings
          } else if(i.choisMeasure !== ingBase.mainMeasure) {
              const crow = ingBase.measure.find(function (j) { 
                return j.nameRu.includes(i.choisMeasure);  
              })
              weight = (crow.ratio*Number(i.weight))/showRecipe.servings
            }
            food.push({
              id: i._id,
              name: showRecipe.name,
              weight: weight, 
              choisMeasure: ingBase.mainMeasure, 
            })   
        } //если в result есть данные 
        else {
          //Проверка наличия этого ингредиента в result
          let check = food.find(с => (с.id === i._id && с.name === showRecipe.name))
          //если есть в массиве то просто прибавляем вес ингредиента
          if(check) {
            food.map((z) => {
              if(z.id === i._id && z.name === showRecipe.name) {
                if(i.choisMeasure === ingBase.mainMeasure) {
                  z.weight += Number(i.weight)/showRecipe.servings
                } else if(i.choisMeasure !== ingBase.mainMeasure) {
                  const crow = ingBase.measure.find(function (j) { 
                    return j.nameRu.includes(i.choisMeasure);  
                  })
                  z.weight += crow.ratio*Number(i.weight)/showRecipe.servings
                }  
              }
            })
          } //если нет ингредиента, то добавляем новый в result
            else if (check === undefined) {
              let weight=0
              if(i.choisMeasure === ingBase.mainMeasure) {
                weight =  Number(i.weight)/showRecipe.servings
              } else if(i.choisMeasure !== ingBase.mainMeasure) {
                const crow = ingBase.measure.find(function (j) { 
                  return j.nameRu.includes(i.choisMeasure);  
                })
                if(crow !==undefined) {
                  weight = (crow.ratio*Number(i.weight))/showRecipe.servings 
                }
              } 
              food.push({
                weight: weight, 
                choisMeasure: ingBase.mainMeasure, 
                id: i._id,
                name: showRecipe.name,
              })   
            }
        }
          })
        }
       })
      }
    })

  })
  return food 
}